export default "__VITE_ASSET__d56ad3bf__"